<template>
    <div
      ref="container"
      class="w-100 h-100 d-flex align-items-center"
      :style="cssVars">
      <div class="w-100">
        <div class="traficLight w-100 d-flex justify-content-center align-items-center mb-2" style="gap: 1rem">
          <div class="outter">
            <div class="innerCircle w-100 h-100" :style="innerCircleColor" ref="innerCircle"></div>
          </div>
          <h1 style="color: white;">{{ status }}</h1>
        </div>
  
        <div class="label w-100 text-center">
          <h3 style="color: white;">{{ value }}</h3>
          <h6 style="color: white;">{{ unit }}</h6>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      value: { type: Number, default: 80 },
      info: { type: Object, required: true },
      fullscreen: { type: Boolean, default: false },
      divisionsColorList: { type: Array, required: true }
    },
    data() {
      return {
        cardWidth: 300,  // has a sensible initial value
        ratio: 1
      };
    },
    computed: {
      cssVars() {
        // compute all CSS variables with safe defaults and units
        if (this.fullscreen) {
          return {
            '--outterCircleSize': `${(window.innerWidth / 100) * 10}px`,
            '--statusSize':      `${(window.innerWidth / 150) * 10}px`,
            '--valueSize':       `${(window.innerWidth / 100) * 5}px`,
            '--unitSize':        `${(window.innerWidth / 100) * 5}px`
          };
        }
  
        let outter = this.cardWidth * 0.1197;
        let status = this.cardWidth * 0.0998; // (typo fixed in var name)
        let value  = this.cardWidth * 0.0625;
        let unit   = this.cardWidth * 0.04;
  
        if (this.ratio < 0.34) {
          outter /= 2.25;
          status /= 2.25;
          value  /= 2.25;
          unit   /= 2.25;
        }
        return {
          '--outterCircleSize': `${outter}px`,
          '--statusSize':       `${status}px`,
          '--valueSize':        `${value}px`,
          '--unitSize':         `${unit}px`
        };
      },
      unit() {
        return this.info.unit ? this.info.unit : 'unidade';
      },
      max() {
        return this.info.maximum != null ? this.info.maximum : 100;
      },
      innerCircleColor() {
        const color = (this.divisionsColorList?.[0]?.color) || '#00ff00';
        return { '--innerCircleColor': color };
      },
      status() {
        const t = this.divisionsColorList?.[0]?.text;
        return t ? t : 'Status';
      }
    },
    methods: {
      resizeMeasurer(w, h) {
        this.ratio = h / w;
        this.cardWidth = w;
      },
      _updateFromContainer() {
        if (!this.$refs.container) return;
        const el = this.$refs.container;
        this.resizeMeasurer(el.offsetWidth, el.offsetHeight);
      },
      _installResizeObserver() {
        // Keep sizes reactive when the parent resizes
        if (typeof ResizeObserver !== 'undefined') {
          this._ro = new ResizeObserver(() => this._updateFromContainer());
          this._ro.observe(this.$refs.container);
        } else {
          // Fallback
          window.addEventListener('resize', this._updateFromContainer);
        }
      }
    },
    mounted() {
      // Make sure vars exist immediately and then stay updated:
      this.$nextTick(() => {
        this._updateFromContainer();
        this._installResizeObserver();
      });
    },
    beforeDestroy() {
      if (this._ro) this._ro.disconnect();
      else window.removeEventListener('resize', this._updateFromContainer);
    }
  };
  </script>
  
  <style scoped>
  .outter {
    height: 100%;
    width: 10%;
    min-width: 3rem;
    border-radius: 100%;
    background: rgba(255, 255, 255, 0.411);
    padding: 0.125rem;
  }
  
  .innerCircle {
    padding: 50%;
    border-radius: 100%;
    background: var(--innerCircleColor, #00ff00); /* fallback color */
    animation: blink 0.75s ease-in-out alternate-reverse infinite;
  }
  
  /* Add FALLBACKS so the browser never resolves to 0/invalid */
  h1 { font-size: var(--statusSize, 20px); }
  h3 { font-size: var(--valueSize, 16px); }
  h6 { font-size: var(--unitSize, 12px); }
  
  @keyframes blink {
    0%   { opacity: 0.625; }
    100% { opacity: 1; }
  }
  </style>
  